export const stateName = 'wallet';